import styled from 'styled-components';

// Order History Tab Styles
export const OrderHistorySection = styled.section`
  max-width: 1728px;
  margin: 0 auto;
  padding: 0 144px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 34px;
`;

export const OrderHistoryHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OrderHistoryTitle = styled.h2`
  font-family: 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
`;

export const TotalOrdersCard = styled.div`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  height: 133px;
  padding: 30px 45px;
  position: relative;
`;

export const TotalOrdersLabel = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.32px;
  margin-bottom: 11px;
`;

export const TotalOrdersValue = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 24px;
`;

export const TotalOrdersNumber = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 40px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.8px;
  height: 38px;
`;

export const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 6px;
  background: transparent;
  border: 1px solid #353535;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #07d993;
  }
`;

export const RefreshIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const RefreshText = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.32px;
`;

export const OrdersTableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 5;
`;

export const OrdersTableTitle = styled.h2`
  font-family: 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
  padding-left: 45px;
`;

export const FiltersBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
  z-index: 20; /* 드롭다운이 테이블 위에 표시되도록 */
`;

export const FiltersLeft = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  z-index: 10; /* 드롭다운이 테이블 위에 표시되도록 */
`;

export const FiltersRight = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const FilterDropdown = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 4px 8px 4px 12px;
  background: rgba(91, 93, 107, 0.3);
  border-radius: 8px;
  cursor: pointer;
  width: ${(props) => (props.$isActive ? '248px' : '165px')};
`;

export const FilterText = styled.span<{ $isActive?: boolean }>`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => (props.$isActive ? '#ffffff' : '#b3b5bd')};
  letter-spacing: -0.32px;
`;

export const FilterArrow = styled.img`
  width: 20px;
  height: 20px;
`;

export const ReloadButton = styled.button`
  width: 36px;
  height: 36px;
  padding: 10px;
  background: rgba(91, 93, 107, 0.3);
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(91, 93, 107, 0.5);
  }
`;

export const ReloadIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const EmptyText = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #777986;
  text-align: center;
  padding: 100px 0;
`;

// Order History 전용 Ant Design Table 스타일 (AssetOverall 스타일 참고)
export const OrderTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 30px 0;
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  border: none;
  min-height: 400px;

  .ant-table-wrapper {
    .ant-table {
      background: transparent;

      .ant-table-thead > tr > th {
        background: rgba(255, 255, 255, 0.05);
        border-bottom: none;
        font-family: 'NanumSquareRound', sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #777986;
        letter-spacing: -0.28px;
        padding: 15px 16px;

        &:first-child {
          padding-left: 45px;
        }

        &:last-child {
          padding-right: 45px;
        }

        &::before {
          display: none !important;
        }
      }

      .ant-table-tbody > tr {
        background: transparent;
        border-bottom: none;

        > td {
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          font-family: 'NanumSquareRound', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          letter-spacing: -0.28px;
          padding: 12px 16px;

          &:first-child {
            padding-left: 45px;
          }

          &:last-child {
            padding-right: 45px;
          }
        }

        &:hover > td {
          background: rgba(255, 255, 255, 0.02);
        }
      }

      .ant-table-placeholder {
        background: transparent;

        .ant-table-cell {
          border-bottom: none;
        }

        .ant-empty-description {
          color: #777986;
        }
      }
    }

    .ant-spin-nested-loading > .ant-spin-container::after {
      background: transparent;
    }

    .ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
      background: transparent;
    }

    /* 스크롤바 스타일 개선 */
    .ant-table-content {
      overflow-x: auto;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
        margin: 0 45px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(7, 217, 147, 0.3);
        border-radius: 3px;

        &:hover {
          background: rgba(7, 217, 147, 0.5);
        }
      }
    }

    /* 빈 상태일 때 스크롤바 숨김 */
    .ant-table-empty .ant-table-content {
      overflow-x: hidden;
    }
  }
`;

export const OrderTableHeader = styled.div`
  margin-bottom: 0;
  padding: 0 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  h3 {
    margin: 0;
    font-family: 'NanumSquareRound', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.32px;
  }
`;

export const SubText = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.28px;
`;

// 상태 태그 스타일
export const OrderStatusTag = styled.span<{ $status: number | string }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.$status === 1 || props.$status === '1'
      ? 'rgba(7, 217, 147, 0.2)'
      : props.$status === 0 || props.$status === '0'
        ? 'rgba(255, 193, 7, 0.2)'
        : 'rgba(255, 77, 79, 0.2)'};
  color: ${(props) =>
    props.$status === 1 || props.$status === '1'
      ? '#07d993'
      : props.$status === 0 || props.$status === '0'
        ? '#ffc107'
        : '#ff4d4f'};
`;

// 방향 태그 스타일
export const DirectionTag = styled.span<{ $isLong: boolean }>`
  font-weight: 600;
  color: ${(props) => (props.$isLong ? '#07d993' : '#ef4444')};
`;

// 금액 텍스트 스타일
export const AmountText = styled.span<{ $positive?: boolean }>`
  font-weight: 600;
  color: ${(props) =>
    props.$positive === undefined
      ? '#ffffff'
      : props.$positive
        ? '#07d993'
        : '#ef4444'};
`;

// 레거시 스타일 (하위 호환성)
export const OrderTableHeaderCell = styled.div<{
  $width?: string;
  $align?: 'left' | 'right' | 'center';
}>`
  flex: ${(props) => props.$width || '1'};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #777986;
  letter-spacing: -0.28px;
  text-align: ${(props) => props.$align || 'left'};
`;

export const OrderTableBody = styled.div`
  padding: 0 45px;
`;

export const OrderTableRow = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

export const OrderTableCell = styled.div<{
  $width?: string;
  $align?: 'left' | 'right' | 'center';
  $color?: string;
}>`
  flex: ${(props) => props.$width || '1'};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.$color || '#ffffff'};
  letter-spacing: -0.28px;
  text-align: ${(props) => props.$align || 'left'};
`;

export const OrderEmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

// Following Portfolio Table 스타일 (Ant Design Table)
export const FollowingTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 30px 0;
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  border: none;
  min-height: 400px;

  .ant-table-wrapper {
    .ant-table {
      background: transparent;

      .ant-table-thead > tr > th {
        background: rgba(255, 255, 255, 0.05);
        border-bottom: none;
        font-family: 'NanumSquareRound', sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #777986;
        letter-spacing: -0.28px;
        padding: 15px 16px;

        &:first-child {
          padding-left: 45px;
        }

        &:last-child {
          padding-right: 45px;
        }

        &::before {
          display: none !important;
        }
      }

      .ant-table-tbody > tr {
        background: transparent;
        border-bottom: none;

        > td {
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          font-family: 'NanumSquareRound', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          letter-spacing: -0.28px;
          padding: 12px 16px;

          &:first-child {
            padding-left: 45px;
          }

          &:last-child {
            padding-right: 45px;
          }
        }

        &:hover > td {
          background: rgba(255, 255, 255, 0.02);
        }
      }

      .ant-table-placeholder {
        background: transparent;

        .ant-table-cell {
          border-bottom: none;
        }

        .ant-empty-description {
          color: #777986;
        }
      }
    }

    .ant-spin-nested-loading > .ant-spin-container::after {
      background: transparent;
    }

    .ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
      background: transparent;
    }

    /* 스크롤바 스타일 개선 */
    .ant-table-content {
      overflow-x: auto;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
        margin: 0 45px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(7, 217, 147, 0.3);
        border-radius: 3px;

        &:hover {
          background: rgba(7, 217, 147, 0.5);
        }
      }
    }

    /* 빈 상태일 때 스크롤바 숨김 */
    .ant-table-empty .ant-table-content {
      overflow-x: hidden;
    }
  }
`;

export const FollowingStatusTag = styled.span<{ $status: number }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.$status === 1
      ? 'rgba(7, 217, 147, 0.2)'
      : props.$status === 2
        ? 'rgba(255, 193, 7, 0.2)'
        : 'rgba(255, 77, 79, 0.2)'};
  color: ${(props) =>
    props.$status === 1
      ? '#07d993'
      : props.$status === 2
        ? '#ffc107'
        : '#ff4d4f'};
`;

export const FollowingManageButton = styled.button`
  padding: 8px 16px;
  background: rgba(7, 217, 147, 0.15);
  border: none;
  border-radius: 8px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #07d993;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(7, 217, 147, 0.25);
  }
`;

export const PnlText = styled.span<{ $positive: boolean }>`
  font-weight: 600;
  color: ${(props) => (props.$positive ? '#07d993' : '#ef4444')};
`;
